import React from 'react';
import InfoCard from '../../Forms/InfoCard/InfoCard';

interface ProductInfo {
  code: string;
  name: string;
  category: string;
  unit: string;
  unitCost: number;
}

interface Props {
  productInfo?: ProductInfo; // <-- Hacemos que sea opcional
}

const ProductInfoCard: React.FC<Props> = ({ productInfo }) => {
  if (!productInfo) return null; // Evita renderizar si aún no hay datos

  return (
    <div className="rounded border border-stroke bg-white p-4 shadow dark:border-strokedark dark:bg-boxdark">
      <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
        Información del Producto
      </h3>

      <div className="space-y-2 text-sm">
        <InfoCard label="Código" value={productInfo.code} iconKey="barcode" />
        <InfoCard label="Nombre" value={productInfo.name} iconKey="product" />
        <InfoCard
          label="Categoría"
          value={productInfo.category}
          iconKey="category"
        />
        <InfoCard label="Unidad" value={productInfo.unit} iconKey="unit" />
        <InfoCard
          label="Costo Unitario"
          value={productInfo.unitCost.toFixed(2)}
          iconKey="dollar"
        />
      </div>
    </div>
  );
};

export default ProductInfoCard;
